import { render, staticRenderFns } from "./SendCredits.vue?vue&type=template&id=ef89ca32&scoped=true&"
import script from "./SendCredits.vue?vue&type=script&lang=js&"
export * from "./SendCredits.vue?vue&type=script&lang=js&"
import style0 from "./SendCredits.vue?vue&type=style&index=0&id=ef89ca32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef89ca32",
  null
  
)

export default component.exports